import { render } from "./AllPromotionsModal.vue?vue&type=template&id=953e093c&scoped=true"
import script from "./AllPromotionsModal.vue?vue&type=script&lang=js"
export * from "./AllPromotionsModal.vue?vue&type=script&lang=js"

import "./AllPromotionsModal.vue?vue&type=style&index=0&id=953e093c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953e093c"]])

export default __exports__